import React, { useEffect, useState } from "react";
import style from "css/device.module.css";

function Experience() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={style.device_experience_wrap}>
      <div className={style.device_experience_title}>
        Neat는 <span>협업을 위한<br />모든 업무공간</span>에 특화된
        <br />
        최첨단 기술의 장비입니다.
      </div>
      <div className={style.device_experience_list}>
        <div className={style.device_experience_list_item}>
          <div className={style.device_experience_img_wrap}>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/experience_1${isMobile ? "_m" : ""}.webp`
              }
              alt="experience1"
            />
          </div>
          <div className={style.device_experience_text_wrap}>
            <div className={style.device_experience_label_wrap}>
              <div className={style.device_experience_item_index}>
                {"neat experience " + "1".padStart(2, "0")}
              </div>
              <div className={style.device_experience_item_label}>
                Zoom & Microsoft & USB BYOD
              </div>
            </div>
            <div className={style.device_experience_text}>
              {
                "Zoom과 Microsoft Teams를 지원하여 최상의 미팅환경을 제공합니다.\n또한 개인형 장치를 USB와 HDMI를 통해 연결할 수도 있습니다."
              }
            </div>
          </div>
        </div>
        <div className={style.device_experience_list_item}>
          <div className={style.device_experience_img_wrap}>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/experience_2${isMobile ? "_m" : ""}.webp`
              }
              alt="experience2"
            />
          </div>
          <div className={style.device_experience_text_wrap}>
            <div className={style.device_experience_label_wrap}>
              <div className={style.device_experience_item_index}>
                {"neat experience " + "2".padStart(2, "0")}
              </div>
              <div className={style.device_experience_item_label}>
                모든 참석자를 위한 <span>스마트 오토 포커싱</span>
              </div>
            </div>
            <div className={style.device_experience_text}>
              {`Neat Symmetry 기술은 회의실에 참석한 모든 사람들이 모두 같은 위치에${isMobile ? " " : "\n"}가깝게 있는 것처럼 보여줍니다. 참석자가 이동을 할 때도 자동으로 따라갑니다.`}
            </div>
          </div>
        </div>
        <div className={style.device_experience_list_item}>
          <div className={style.device_experience_img_wrap}>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/experience_3${isMobile ? "_m" : ""}.webp`
              }
              alt="experience3"
            />
          </div>
          <div className={style.device_experience_text_wrap}>
            <div className={style.device_experience_label_wrap}>
              <div className={style.device_experience_item_index}>
                {"neat experience " + "3".padStart(2, "0")}
              </div>
              <div className={style.device_experience_item_label}>
                회의에 집중할 수 있는 <span>Boundary 기술</span>
              </div>
            </div>
            <div className={style.device_experience_text}>
              {
                "Neat boundary 기능은 프레임 공간을 설정하면 공간 내 회의 참석자만 팔로우 합니다.\n경계 밖의 사용자를 팔로우 하는 것을 방지합니다."
              }
            </div>
          </div>
        </div>
        <div className={style.device_experience_list_item}>
          <div className={style.device_experience_img_wrap}>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/experience_4${isMobile ? "_m" : ""}.webp`
              }
              alt="experience4"
            />
          </div>
          <div className={style.device_experience_text_wrap}>
            <div className={style.device_experience_label_wrap}>
              <div className={style.device_experience_item_index}>
                {"neat experience " + "4".padStart(2, "0")}
              </div>
              <div className={style.device_experience_item_label}>
                목소리는 높이고! <span>소음은 줄이고!</span>
              </div>
            </div>
            <div className={style.device_experience_text}>
              {
                "참석자의 음성은 향상시키고 선풍기나 키보드 콜린 같은 잡음은 걸러 줍니다.\n이중 대화 감지를 통해 대화가 중단되지 않게 도움을 줍니다."
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Experience;
